/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { GetPhotoSubmissionsItem } from './GetPhotoSubmissionsItem';
import {
    GetPhotoSubmissionsItemFromJSON,
    GetPhotoSubmissionsItemFromJSONTyped,
    GetPhotoSubmissionsItemToJSON,
    GetPhotoSubmissionsItemToJSONTyped,
} from './GetPhotoSubmissionsItem';

/**
 * 
 * @export
 * @interface GetPhotoSubmissionsResponse
 */
export interface GetPhotoSubmissionsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetPhotoSubmissionsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<GetPhotoSubmissionsItem>}
     * @memberof GetPhotoSubmissionsResponse
     */
    photoSubmissions?: Array<GetPhotoSubmissionsItem>;
}

/**
 * Check if a given object implements the GetPhotoSubmissionsResponse interface.
 */
export function instanceOfGetPhotoSubmissionsResponse(value: object): value is GetPhotoSubmissionsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    return true;
}

export function GetPhotoSubmissionsResponseFromJSON(json: any): GetPhotoSubmissionsResponse {
    return GetPhotoSubmissionsResponseFromJSONTyped(json, false);
}

export function GetPhotoSubmissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPhotoSubmissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'photoSubmissions': json['photoSubmissions'] == null ? undefined : ((json['photoSubmissions'] as Array<any>).map(GetPhotoSubmissionsItemFromJSON)),
    };
}

export function GetPhotoSubmissionsResponseToJSON(json: any): GetPhotoSubmissionsResponse {
    return GetPhotoSubmissionsResponseToJSONTyped(json, false);
}

export function GetPhotoSubmissionsResponseToJSONTyped(value?: GetPhotoSubmissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'photoSubmissions': value['photoSubmissions'] == null ? undefined : ((value['photoSubmissions'] as Array<any>).map(GetPhotoSubmissionsItemToJSON)),
    };
}

